import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_report_restriction_entity_value_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { entity: string, full_text_search?: string, optional_filters?: { owner_id?: number }, $top?: number, $skip?: number }): Promise<{ result?: { entity_id?: number, entity_label?: string, entity?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.entity)) {
      $missingRequiredInParams.push('\'entity\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { entity?: string, full_text_search?: string, optional_filters?: { owner_id?: number }, $keys: { entity_id?: number, entity?: string }[] }): Promise<{ result?: { entity_id?: number, entity_label?: string, entity?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      entity: string, full_text_search?: string, optional_filters?: { owner_id?: number }    }) {
        if(isNil($inParams.entity)) {
          return true; 
        }
      return false;
    }
}
